// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-toolbar {
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;
  position: relative;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: height, width, transform, max-width, left, right, top, bottom, box-shadow;
  width: 100%;
}
@media (prefers-reduced-motion: reduce) {
  :where(.vuetify-styles) .v-toolbar {
    transition-property: box-shadow;
  }
}
:where(.vuetify-styles) .v-toolbar {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-toolbar--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-toolbar {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-toolbar {
  border-radius: 0;
}
:where(.vuetify-styles) .v-toolbar {
  background: rgb(var(--v-theme-surface-light));
  color: rgba(var(--v-theme-on-surface-light), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-toolbar--absolute {
  position: absolute;
}
:where(.vuetify-styles) .v-toolbar--collapse {
  max-width: 112px;
  overflow: hidden;
}
:where(.vuetify-styles) .v-toolbar--collapse-end {
  margin-inline-start: auto;
}
:where(.vuetify-styles) .v-toolbar--collapse.v-toolbar--collapse-start {
  border-end-end-radius: 24px;
}
:where(.vuetify-styles) .v-toolbar--collapse.v-toolbar--collapse-end {
  border-end-start-radius: 24px;
}
:where(.vuetify-styles) .v-toolbar--collapse .v-toolbar-title {
  display: none;
}
:where(.vuetify-styles) .v-toolbar--flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-toolbar--floating {
  display: inline-flex;
  width: auto;
}
:where(.vuetify-styles) .v-toolbar--rounded {
  border-radius: 4px;
}

:where(.vuetify-styles) .v-toolbar__content,
:where(.vuetify-styles) .v-toolbar__extension {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  position: relative;
  transition: inherit;
  width: 100%;
}

:where(.vuetify-styles) .v-toolbar__content {
  overflow: hidden;
}
:where(.vuetify-styles) .v-toolbar__content > .v-btn:first-child {
  margin-inline-start: 4px;
}
:where(.vuetify-styles) .v-toolbar__content > .v-btn:last-child {
  margin-inline-end: 4px;
}
:where(.vuetify-styles) .v-toolbar__content > .v-toolbar-title {
  margin-inline-start: 20px;
}
:where(.vuetify-styles) .v-toolbar--density-prominent .v-toolbar__content {
  align-items: flex-start;
}

:where(.vuetify-styles) .v-toolbar__image {
  display: flex;
  opacity: var(--v-toolbar-image-opacity, 1);
  transition-property: opacity;
}
:where(.vuetify-styles) .v-toolbar__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-toolbar__prepend,
:where(.vuetify-styles) .v-toolbar__append {
  align-items: center;
  align-self: stretch;
  display: flex;
}

:where(.vuetify-styles) .v-toolbar__prepend {
  margin-inline: 4px auto;
}

:where(.vuetify-styles) .v-toolbar__append {
  margin-inline: auto 4px;
}

:where(.vuetify-styles) .v-toolbar-title {
  flex: 1 1;
  font-size: 1.25rem;
  min-width: 0;
}
:where(.vuetify-styles) .v-toolbar-title {
  font-size: 1.25rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.75rem;
  text-transform: none;
}
:where(.vuetify-styles) .v-toolbar--density-prominent .v-toolbar-title {
  align-self: flex-end;
  padding-bottom: 6px;
}
:where(.vuetify-styles) .v-toolbar--density-prominent .v-toolbar-title {
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 2.25rem;
  text-transform: none;
}

:where(.vuetify-styles) .v-toolbar-title__placeholder {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:where(.vuetify-styles) .v-toolbar-items {
  display: flex;
  height: inherit;
  align-self: stretch;
}
:where(.vuetify-styles) .v-toolbar-items > .v-btn {
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VToolbar/VToolbar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,8FAA8F;EAC9F,WAAW;AACb;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,4EAA4E;AAC9E;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,sOAAsO;AACxO;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".v-toolbar {\n  align-items: flex-start;\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  justify-content: space-between;\n  max-width: 100%;\n  position: relative;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-property: height, width, transform, max-width, left, right, top, bottom, box-shadow;\n  width: 100%;\n}\n@media (prefers-reduced-motion: reduce) {\n  .v-toolbar {\n    transition-property: box-shadow;\n  }\n}\n.v-toolbar {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-toolbar--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-toolbar {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-toolbar {\n  border-radius: 0;\n}\n.v-toolbar {\n  background: rgb(var(--v-theme-surface-light));\n  color: rgba(var(--v-theme-on-surface-light), var(--v-high-emphasis-opacity));\n}\n.v-toolbar--absolute {\n  position: absolute;\n}\n.v-toolbar--collapse {\n  max-width: 112px;\n  overflow: hidden;\n}\n.v-toolbar--collapse-end {\n  margin-inline-start: auto;\n}\n.v-toolbar--collapse.v-toolbar--collapse-start {\n  border-end-end-radius: 24px;\n}\n.v-toolbar--collapse.v-toolbar--collapse-end {\n  border-end-start-radius: 24px;\n}\n.v-toolbar--collapse .v-toolbar-title {\n  display: none;\n}\n.v-toolbar--flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-toolbar--floating {\n  display: inline-flex;\n  width: auto;\n}\n.v-toolbar--rounded {\n  border-radius: 4px;\n}\n\n.v-toolbar__content,\n.v-toolbar__extension {\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  position: relative;\n  transition: inherit;\n  width: 100%;\n}\n\n.v-toolbar__content {\n  overflow: hidden;\n}\n.v-toolbar__content > .v-btn:first-child {\n  margin-inline-start: 4px;\n}\n.v-toolbar__content > .v-btn:last-child {\n  margin-inline-end: 4px;\n}\n.v-toolbar__content > .v-toolbar-title {\n  margin-inline-start: 20px;\n}\n.v-toolbar--density-prominent .v-toolbar__content {\n  align-items: flex-start;\n}\n\n.v-toolbar__image {\n  display: flex;\n  opacity: var(--v-toolbar-image-opacity, 1);\n  transition-property: opacity;\n}\n.v-toolbar__image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.v-toolbar__prepend,\n.v-toolbar__append {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n}\n\n.v-toolbar__prepend {\n  margin-inline: 4px auto;\n}\n\n.v-toolbar__append {\n  margin-inline: auto 4px;\n}\n\n.v-toolbar-title {\n  flex: 1 1;\n  font-size: 1.25rem;\n  min-width: 0;\n}\n.v-toolbar-title {\n  font-size: 1.25rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.75rem;\n  text-transform: none;\n}\n.v-toolbar--density-prominent .v-toolbar-title {\n  align-self: flex-end;\n  padding-bottom: 6px;\n}\n.v-toolbar--density-prominent .v-toolbar-title {\n  font-size: 1.5rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 2.25rem;\n  text-transform: none;\n}\n\n.v-toolbar-title__placeholder {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.v-toolbar-items {\n  display: flex;\n  height: inherit;\n  align-self: stretch;\n}\n.v-toolbar-items > .v-btn {\n  border-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
